<idt-common-styles-render
  *ngIf="piece"
  [styles]="piece.settings?.styles">

  @let orientation = orientation$ | async;
  <ng-container>
    <render-link
      *ngIf="!!settings && !!settings.general.link.type"
      [lang]="lang"
      [link]="settings.general.link"
      [piece]="piece"
      (renderLinkEvent)="onRenderLinkClick($event)">
      <ng-container *ngTemplateOutlet="imageSelector"></ng-container>
    </render-link>

    <ng-container *ngIf="!!settings && !settings.general.link.type">
      <ng-container *ngTemplateOutlet="imageSelector"></ng-container>
    </ng-container>

    <ng-template #imageSelector>
      @if (orientation === 'landscape') {
        @let lazySrc = getLandscapeImageSrc();
        <img
          alt="{{ lazySrc!.src! | getAltText: settings.general.alt | async }}"
          [lazySrc]="lazySrc"
          [preRender]="!!settings.general.preloadImage"
          [attr.title]="settings.general.title" />
      } @else {
        @let lazySrc = getPortraitImageSrc();
        <img
          alt="{{ lazySrc!.src! | getAltText: settings.general.alt | async }}"
          [lazySrc]="lazySrc"
          [preRender]="!!settings.general.preloadImage"
          [attr.title]="settings.general.title">
      }
    </ng-template>
  </ng-container>
</idt-common-styles-render>
